import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" {...props}><path d="M9.968.847c.425 0 .769.344.769.77v12.845l3.038-3.038a.77.77 0 011.088 1.088l-4.352 4.351a.775.775 0 01-1.088 0l-4.35-4.351a.768.768 0 111.087-1.088l3.04 3.038V1.616c0-.425.343-.769.769-.769zM20 19H0v1.563h20V19z" fill="#263E6A" fillRule="nonzero" /></svg>;